<template>
  <v-container>
    <v-card>
      <v-row>
        <v-col cols="3" class="user__image-wrapper">
          <v-img class="user__image user__image--new" :src="form.meta.image"></v-img>
          <v-img class="user__image user__image--original" :src="original.meta.image" @click="form.meta.image = original.meta.image"></v-img>
        </v-col>
        <v-col>
          <v-form ref='form' v-model="valid">
            <v-row no-gutters>
              <v-col>
                <v-card-title>
                  <span>{{form.name}}</span>
                  <v-text-field v-if="isAdmin" type="number" v-model="form.player_id" @change="handlePlayerChange" min="1" :max="players.length || 1"></v-text-field>
                  <v-text-field v-if="isAdmin" v-model="form.kakao_id"></v-text-field>
                </v-card-title>
              </v-col>
              <v-autocomplete
                  v-show="isNew"
                  v-model="form.player_id" label="Select Player"
                  :items="[...players.filter(({kakao_id}) => !kakao_id), {name: 'New', id: 'new'}]"
                  item-text="name"
                  item-value="player_id"
                  :disabled="!isNew"
                  :rules="[(v)=> !!v || '플레이어를 선택해주세요']"
              ></v-autocomplete>
            </v-row>
            <v-text-field v-model="form.meta.image" label="image url"></v-text-field>
            <v-btn ref="colorBtn" tile disabled :style="`background-color:${form.color} !important`">유저컬러</v-btn>
            <v-color-picker v-model="selectedColor" type="rgba" canvas-height="100px" @input="updateColor"></v-color-picker>
          </v-form>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="auto"><v-btn @click="saveUser">저장</v-btn></v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { getPlayerByPlayerId, getPlayers, savePlayer } from "@/api/player";
import { deepClone } from "@/util/nativeHelper";

export default {
  name: "User",
  data() {
    return {
      players: [],
      selectedColor: null,

      original: {
        meta: {}
      },
      isNew: false,
      valid: false,
      form: {
        meta: {}
      }
    }
  },
  computed: {
    ...mapGetters(['loginRequestCount','kakaoData']),
    isLogin() {
      this.loginRequestCount;
      return this.$session.exists()
    },
    isAdmin() {
      return (this.$session.get('loginUser') || {}).player_id === 1
    }
  },
  watch: {
    'form.player_id'(val){
      this.form.name = this.players.find(({player_id})=> `${player_id}` === `${val}`).name
    },
    'form.name'(newval,oldval){
      if(newval !== oldval){
        this.form.name = newval.slice(-2)
      }
    },
    isLogin(){
      if(!this.isLogin){this.$store.dispatch('auth/openLoginDialog')}
      this.getLoginUser()
    },
    kakaoData() {
      this.getLoginUser()
    }
  },
  async mounted(){
    this.players = await getPlayers()
    await this.getLoginUser()
  },
  methods: {
    async handlePlayerChange(v){
      this.form = await getPlayerByPlayerId(v)
      this.afterUserLoad()
    },
    updateColor(v){
      v = (v || this.selectedColor)
      v = v.rgba || v
      console.debug(JSON.stringify(v))
      this.form.color = `rgba(${v.r},${v.g},${v.b},${v.a})`
    },
    async getLoginUser(){
      let user = this.$session.get('loginUser')
      if(user){
        this.form = await getPlayerByPlayerId(user.player_id)
      }else if(this.kakaoData){
        this.form = this.kakaoData.player
        this.isNew = true
      }
      this.afterUserLoad()
    },
    afterUserLoad() {
      this.original = deepClone(this.form)
      if(!this.$refs.colorBtn) return null
      this.$nextTick(() => {
        const color = window.getComputedStyle(this.$refs.colorBtn.$el).backgroundColor
        const keys = ['r','g','b','a']
        const rgba = {'a': 1, ...Object.fromEntries([...color.match(/[\d.]+/g)].map((dat, i) => [keys[i], Number(dat)]))}
        this.selectedColor = rgba
        console.debug('change form.color', JSON.stringify(this.selectedColor))
      })
    },
    saveUser(){
      if(!this.$refs.form.validate()) return this.$alert('양식을 확인해주세요','Check','warning')
      this.updateColor()
      return savePlayer(this.form).then(({data}) => {
        if(data.err){
          console.error(data)
          return this.$alert('저장실패','failed','error')
        }
        this.$alert('저장완료','success','success')
        this.isNew = false
      })
    }
  }
}
</script>

<style lang="scss">
  .user__image-wrapper{
    position:relative;

    &:hover{
      .user__image--new{opacity:0.5;}
      .user__image--original{opacity:1;}
    }
  }
  .user__image{
    transition: opacity .5s ease;
  }
  .user__image--original{
    opacity: 0;
    transition: opacity .5s ease;
    position:absolute;
    cursor:pointer;
    box-shadow: 0 0 5px 5px grey;
    padding:0;
    top:0;
    right:0;
    width:30%;
  }
</style>